<template lang="pug">
  #ContactsIndex
    h5.text-center.py-3.letter-spacing-6 客戶通訊錄
    b-card.rounded-0(
      bg-variant="white",
      no-body,
      class="border-0"
    )
      b-card-body.py-2.px-3(
        class="searchArea"
      )
        .row.mb-2
          .col-12.mb-2
            b-input-group
              b-form-input(
                v-model="searchInput.keyword"
                placeholder="請輸入摯友姓名或手機號碼"
              )
              b-input-group-append(@click="searchHandler()")
                b-input-group-text
                  i.fas.fa-search
          .col-10
            b-form-group.mb-3
              b-input-group
                b-select(
                  :option="customerClassOptions",
                  v-model="searchInput.customer_class"
                  @change='setTxMoneyStart()'
                )
                  b-form-select-option(
                    v-for="(option,index) in customerClassOptions",
                    :key="option.id",
                    :value="option.id"
                  ) {{ option.name }}
                //- b-form-input(
                //-   v-model="searchInput.customer_name",
                //-   placeholder="請輸入顧客姓名"
                //- )
            b-collapse#collapse-searchBody
              b-input-group.mb-3
                b-form-select(
                  v-model="searchInput.customer_tr",
                  placeholder="客戶TR"
                )
                  template(
                    v-slot:first
                  )
                    b-form-select-option(
                      :value="null",
                      disabled
                    ) 客戶TR
                    b-form-select-option(
                      :value="'all'",
                    ) 全部
                  b-form-select-option(
                    v-for="(option,index) in tiffanyLevel",
                    :key="option.id",
                    :value="option.name"
                  ) {{ option.name }}
              b-input-group.mb-3
                b-form-select(
                  v-model="searchInput.member_gender",
                  placeholder="性別"
                )
                  template(
                    v-slot:first
                  )
                    b-form-select-option(
                      :value="null",
                      disabled
                    ) 性別
                    b-form-select-option(
                      :value="'all'",
                    ) 全部
                  b-form-select-option(
                    v-for="(option,index) in tiffanyGender",
                    :key="option.id",
                    :value="option.name"
                  ) {{ option.name }}
              b-input-group.mb-3
                b-form-select(
                  v-model="searchInput.customer_birthday_month",
                  placeholder="客戶生日月份"
                )
                  template(
                    v-slot:first
                  )
                    b-form-select-option(
                      :value="null",
                      disabled
                    ) 客戶生日月份
                    b-form-select-option.d-none(
                      :value="''",
                      disabled
                    ) 客戶生日月份
                    b-form-select-option(
                      value="all"
                    ) 全部
                  b-form-select-option(
                    v-for="month in 12",
                    :key="month",
                    :value="month"
                  ) {{ filterMonthToWord(month) }}
              div.mb-3
                b-input-group
                  b-form-input(
                    v-model="searchInput.tx_money_start"
                    placeholder="請輸入消費金額"
                  )
                  .mr-1.ml-1 ~
                  b-form-input(
                    v-model="searchInput.tx_money_end"
                    placeholder="請輸入消費金額"
                  )
                small.redRemind(v-show="searchInput.customer_class === '10K' && ((searchInput.tx_money_start && parseInt(searchInput.tx_money_start, 10) < 300000) || (searchInput.tx_money_end && parseInt(searchInput.tx_money_end, 10) < 300000))") 消費金額不可少於300000
              multiselect(
                v-model="searchInput.tag_id",
                tag-placeholder="",
                placeholder="輸入文字搜尋標籤",
                selectLabel="",
                :showLabels="false",
                deselectLabel="點擊移除標籤",
                selectedLabel="已選擇",
                label="tag_name",
                track-by="tag_id",
                :options="tags",
                :multiple="true",
                :taggable="true",
                noOptions="無標籤"
              )
                template(slot="Label", slot-scope='{ tags }')
                template(slot="noOptions")
                  strong 請按 Enter 新增標籤
          .col-2
            b-button(
              variant="primary",
              block,
              v-b-toggle.collapse-searchBody
            )
              i.fas.fa-align-justify.d-flex.align-items-center.justify-content-center.text-white
        .row.no-gutters
          .col-6.pr-1
            b-button(
              variant="primary",
              block,
              @click="searchHandler()",
              class="text-white"
            ) 搜尋
          .col-6.pl-1
            b-button(
              variant="primary",
              block,
              @click="researtSearchHandler()",
              class="text-white"
            ) 重置
    .p-3.d-flex.align-items-center
      i.fas.fa-users.fa-lg
      span.pl-2 {{ pagination.total ? pagination.total : 0 }} 位
      b-button.ml-2(
        variant="primary",
        @click="selectAllUsers()",
        class="text-black"
        v-show="selectMode"
        style='background-color: #e9ecef; border: 1px solid #ced4da;'
      ) 全選客戶
    div
      .root(ref="root" :style="rootStyle")
        .viewport(ref="viewport" :style="viewportStyle")
          .spacer(ref="spacer" :style="spacerStyle")
            b-card.border-0.mb-2.customerCard.overflow-hidden(
              bg-variant="light",
              v-for="(user,index) in visibleItems",
              @click="showUserInfoHandler(user)",
              body-class="p-0"
            )
              .row
                .col-2.d-flex.align-items-center.justify-content-center(
                  v-show="selectMode"
                )
                  b-form-checkbox(
                    :id="`checkbox-group-${index}`",
                    v-model="selectUsers",
                    :name="`user-${index}`",
                    :value="user",
                    v-show="selectMode"
                  )
                div(
                  :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
                )
                  label.w-100.mb-0(
                    :for="`checkbox-group-${index}`"
                  )
                    .p-3
                      .row.align-items-center.no-gutters.mb-3
                        .col-3.pr-1
                          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                            :profileUrl="user.picture_url",
                            :style="{ 'width': '70px', 'height': '70px' }"
                          )
                        .col-9.pl-1
                          p.mb-0.font-weight-bold.text-17 {{ first_name(user) }}
                          .row.no-gutters
                            .col-6
                              small 暱稱名： {{ user.member_line_display_name }}
                            .col-6
                              small 備註名： {{ user.note_name }}
                            .col-12
                              small ECM ID： {{ user.member_code }}
                            .col-6
                              small.mb-0 客戶TR：
                              b-badge(
                                variant="primary",
                                class="rounded-0 p-1 bg-primary"
                              ) {{ TRList.includes(user.member_level) ? user.member_level : '' }}
                            .col-6
                              small.mb-0 性別：
                              b-badge(
                                variant="primary",
                                class="rounded-0 p-1 bg-primary"
                              ) {{ genderList.includes(user.member_gender) ? user.member_gender : '' }}
                    .py-2.px-3.bg-primary
                      .row.align-items-center.no-gutters
                        .col-6
                          .d-flex.align-items-center
                            i.fas.fa-birthday-cake.mr-2
                            small 生日：{{ filterMonthToWord(user.birthday) }}
                        .col-6
                          small 上次到店資訊日期：{{ user.latest_reservation_date ? user.latest_reservation_date : '-' }}
                        .col-6
                          .d-flex.align-items-center
                            i.fas.fa-mobile-alt.mr-2
                            small 電話：{{ user.mobile || user.reserve_mobile}}
                        .col-6
                          small 上次服務CA：{{ user.latest_reservation_sa_name ? user.latest_reservation_sa_name : '-' }}
                        .col-6
                          small 今年消費金額：{{ user.tx_money!=0 ? user.tx_money : '-' }}
                        .col-6
                          small 上次交易CA：{{ user.tx_sp_name }}
                    .p-3
                      .row.align-items-center.no-gutters
                        .col-6.mb-2
                          .d-flex.align-items-center
                            i.far.fa-calendar-check.mr-2
                            small 負責CA：{{ user.sa_name }}
                        .col-12.mb-2
                          .labelRow.d-flex.align-items-center.flex-wrap.mb-3
                            i.fas.fa-tag.mr-2
                            small 客戶標籤：
                            b-badge.m-1.rounded-0.p-1(
                              variant="primary",
                              v-for="(label,index) in user.tags"
                              :key="label.tag_id"
                            ) {{ label.name }}
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
    //- 群發訊息按鈕
    .button-fixedArea
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.iconBtn.iconPushBtn.border.border-gray.bg-white(
        variant="white",
        @click="selectUserhHandler(true)"
      )
        i.fas.fa-volume-up.iconPush
      small.d-block.w-100.text-center.font-weight-bold.text-black 群發訊息
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.button-close.iconBtn.iconPushBtn(
        variant="gray",
        v-if="selectMode",
        @click="selectUserhHandler(false)"
      )
        i.fas.fa-times
      b-badge.rounded-50.d-flex.align-items-center.justify-content-center.button.button-people.iconBtn.iconPushBtn.p-1(
        pill,
        variant="danger",
        v-if="selectMode"
      )
        span {{ selectUsers.length }}
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_GROUP_PUSH_INDEX } from '@/router/sm/group-push';
import { SM_MY_CUSTOMER_INDEX } from '@/router/sm/my-customer';

const passiveSupportMixin = {
  methods: {
    // This snippet is taken straight from https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    // It will only work on browser so if you are using in an SSR environment, keep your eyes open
    doesBrowserSupportPassiveScroll() {
      let passiveSupported = false;

      try {
        const options = {
          get passive() {
            // This function will be called when the browser
            //   attempts to access the passive property.
            passiveSupported = true;
            return false;
          }
        };

        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
      } catch (err) {
        passiveSupported = false;
      }
      return passiveSupported;
    }
  }
};

export default {
  name: 'ContactsIndex',
mixins: [passiveSupportMixin],
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      customerClassOptions: [
        {
          id: 'binding',
          name: '摯友品牌客戶' // 摯友(品牌顧客) + 封鎖-摯友（品牌客戶）
        },
        {
          id: 'not_binding',
          name: '摯友非品牌客戶' // 摯友(非品牌顧客) + 封鎖-摯友（非品牌顧客）
        },
        {
          id: '10K',
          name: '10K客戶' // 每月上傳名單 今年交易金額 > 10萬
        },
        {
          id: 'others',
          name: '預約服務客戶'
        }
      ],
      searchInput: {
        keyword: '',
        tag_id: [],
        customer_class: 'binding',
        customer_tr: null,
        member_gender: null,
        customer_birthday_month: null,
        tx_money_start: '',
        tx_money_end: ''
      },
      selectMode: false,
      selectUsers: [],
      infiniteId: +new Date(),
      getAllData: false,
// Total height of the root which contains all the list items in px
      rootHeight: 500,
      // Height of each row, give it an initial value but this gets calculated dynamically on mounted
      rowHeight: 100,
      // Current scroll top position, we update this inside the scroll event handler
      scrollTop: 0,
      // Extra padding at the top and bottom so that the items transition smoothly
      // Think of it as extra items just before the viewport starts and just after the viewport ends
      nodePadding: 20
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_contacts/resetHandler');
    vm.$store.dispatch('sm_contacts/getTiffanyMemberLevelAndGenderHandler')
      .then(() => {
        vm.$swal.close();
      });
    vm.getBackendTagsHandler();
  },
mounted() {
    this.$refs.root.addEventListener(
      "scroll",
      this.handleScroll,
      this.doesBrowserSupportPassiveScroll() ? { passive: true } : false
    );
    // Calculate that initial row height dynamically
    const largestHeight = this.calculateInitialRowHeight();
    this.rowHeight =
      typeof largestHeight !== "undefined" && largestHeight !== null
        ? largestHeight
        : 30;
  },
  methods: {
    first_name(user) {
      if (user.member_chinese_last_name && user.member_chinese_first_name) {
        return user.member_chinese_last_name + user.member_chinese_first_name;
      }
      return user.member_line_display_name;
    },
    infiniteHandler($state) {
      const vm = this;
      const tag_arr = [];
      if (vm.searchInput.tag_id.length !== 0) {
        _.forEach(vm.searchInput.tag_id, (val) => tag_arr.push(val.tag_id));
      }
      vm.$store.dispatch('sm_contacts/getMemberListHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.getAllData ? 999999999999 : 999999999,
        filter_type: vm.searchInput.customer_class && vm.searchInput.customer_class !== 'all' ? vm.searchInput.customer_class : null,
        member_level: vm.searchInput.customer_tr && vm.searchInput.customer_tr !== 'all' ? vm.searchInput.customer_tr : null,
        member_gender: vm.searchInput.member_gender && vm.searchInput.member_gender !== 'all' ? vm.searchInput.member_gender : null,
        birthday: vm.searchInput.customer_birthday_month && vm.searchInput.customer_birthday_month !== 'all' ? vm.searchInput.customer_birthday_month : null,
        keyword: vm.searchInput.keyword.trim() !== '' ? vm.searchInput.keyword : null,
        tag_id: vm.searchInput.tag_id.length !== 0 ? tag_arr : null,
        tx_money_start: vm.searchInput.tx_money_start.trim() !== '' ? vm.searchInput.tx_money_start : null,
        tx_money_end: vm.searchInput.tx_money_end.trim() !== '' ? vm.searchInput.tx_money_end : null
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
          if (vm.getAllData) {
            vm.selectUsers = vm.memberList;
            vm.getAllData = false;
          }
        }
      });
    },
    selectUserhHandler(mode) {
      const vm = this;
      // 如果是點推播按鈕且目前在選擇使用者模式
      if (mode && vm.selectMode && vm.selectUsers && vm.selectUsers.length > 0) {
        vm.$store.commit('sm_group_push/setMemberList', vm.selectUsers);
        vm.$router.push({
          name: SM_GROUP_PUSH_INDEX
        });
      } else {
        vm.selectUser = [];
        vm.selectMode = mode;
      }
    },
    showUserInfoHandler(user) {
      const vm = this;
      if (vm.selectMode) return;
      vm.$router.push({
        name: SM_MY_CUSTOMER_INDEX,
        params: {
          user,
          filter_type: vm.searchInput.customer_class
        }
      }).catch(() => {});
    },
    searchHandler() {
      const vm = this;
      vm.$store.commit('sm_contacts/resetHandler');
      vm.checkSearch().then(() => {
        vm.infiniteId += 1;
      });
    },
    researtSearchHandler() {
      const vm = this;
      vm.searchInput.customer_class = 'binding';
      vm.searchInput.customer_tr = null;
      vm.searchInput.member_gender = null;
      vm.searchInput.customer_birthday_month = null;
      vm.searchInput.keyword = '';
      vm.searchInput.tag_id = [];
      vm.searchInput.tx_money_start = '';
      vm.searchInput.tx_money_end = '';
      vm.$store.commit('sm_contacts/resetHandler');
      vm.infiniteId += 1;
    },
    // 取得標籤
    getBackendTagsHandler() {
      const vm = this;
      // 取得標籤
      vm.$store.dispatch('sm_label/getBackendTagsHandler', {
        filter_type: 'binding'
      })
        .then(() => {
          vm.$swal.close();
        });
    },
    selectAllUsers() {
      const vm = this;
      if (vm.memberList.length !== vm.pagination.total) {
        vm.getAllData = true;
        vm.$store.commit('sm_contacts/resetHandler');
        vm.infiniteId += 1;
      } else {
        vm.selectUsers = vm.memberList;
      }
    },
    setTxMoneyStart() {
      const vm = this;
      if (vm.searchInput.customer_class !== '10K') {
        vm.searchInput.tx_money_start = '';
        vm.searchInput.tx_money_end = '';
        return;
      }
      if (!vm.searchInput.tx_money_start || parseInt(vm.searchInput.tx_money_start, 10) < 300000) vm.searchInput.tx_money_start = '300000';
      if (vm.searchInput.tx_money_end && parseInt(vm.searchInput.tx_money_end, 10) < 300000) vm.searchInput.tx_money_end = '';
    },
    checkSearch() {
      const vm = this;
      return new Promise((resolve) => {
        if (vm.searchInput.customer_class === '10K') {
          if ((!vm.searchInput.tx_money_start || parseInt(vm.searchInput.tx_money_start, 10) < 300000) || (vm.searchInput.tx_money_start && parseInt(vm.searchInput.tx_money_end, 10) < 300000)) {
            vm.$swal.fire({
              title: '消費金額無法低於300000',
              icon: 'info'
            });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
handleScroll(event) {
      this.scrollTop = this.$refs.root.scrollTop;
    },
    /**
    Find the largest height amongst all the children
    Remember each row has to be of the same height
    I am working on the different height version
    */
    calculateInitialRowHeight() {
      const children = this.$refs.spacer.children;
      console.log(children)
      let largestHeight = 500;
      for (let i = 0; i < children.length; i++) {
        if (children[i].offsetHeight > largestHeight) {
          console.log('123',children[i].offsetHeight)
          largestHeight = children[i].offsetHeight;
        }
      }
      return largestHeight;
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sm_contacts.memberList,
      pagination: (state) => state.sm_contacts.pagination,
      tiffanyLevel: (state) => state.sm_contacts.tiffanyLevel,
      tiffanyGender: (state) => state.sm_contacts.tiffanyGender,
      tags: (state) => state.sm_label.tags,
      TRList: (state) => state.sa.TRList,
      genderList: (state) => state.sa.genderList,
    }),
    /**
    Total height of the viewport = number of items in the array x height of each item
    */
    viewportHeight() {
      return this.itemCount * this.rowHeight;
    },
    /**
    Out of all the items in the massive array, we only render a subset of them
    This is the starting index from which we show a few items
    */
    startIndex() {
      let startNode =
        Math.floor(this.scrollTop / this.rowHeight) - this.nodePadding;
      startNode = Math.max(0, startNode);
      console.log(this.scrollTop, this.rowHeight, this.nodePadding)
      console.log(Math.floor(this.scrollTop / this.rowHeight) - this.nodePadding)
      return startNode;
    },
    /**
    This is the number of items we show after the starting index
    If the array has a total 10000 items, we want to show items from say index 1049 till 1069
    visible node count is that number 20 and starting index is 1049
    */
    visibleNodeCount() {
      let count =
        Math.ceil(this.rootHeight / this.rowHeight) + 2 * this.nodePadding;
      count = Math.min(this.itemCount - this.startIndex, count);
      return count;
    },
    /**
    Subset of items shown from the full array
    */
    visibleItems() {
      return this.memberList.slice(
        this.startIndex,
        this.startIndex + this.visibleNodeCount
      );
    },
    itemCount() {
      return this.memberList.length;
    },
    /**
    The amount by which we need to translateY the items shown on the screen so that the scrollbar shows up correctly
    */
    offsetY() {
      return this.startIndex * this.rowHeight;
    },
    /**
    This is the direct list container, we apply a translateY to this
    */
    spacerStyle() {
      return {
        transform: "translateY(" + this.offsetY + "px)"
      };
    },
    viewportStyle() {
      return {
        overflow: "hidden",
        height: this.viewportHeight + "px",
        position: "relative"
      };
    },
    rootStyle() {
      return {
        height: this.rootHeight + "px",
        overflow: "auto"
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    vm.$store.commit('sm_contacts/resetHandler');
    next();
  },
  destroyed() {
    this.$refs.root.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
